module.exports = __webpack_public_path__ + "img/error-403.98bba5b1.svg";